// Dropdown Menu JavaScript
class DropdownMenu {
    constructor() {
        this.initializeElements();
        this.bindEvents();
        this.isDesktop = window.innerWidth > 768;
    }

    initializeElements() {
        this.dropdownTrigger = document.getElementById('categoriesBtn');
        this.dropdownMenu = document.getElementById('mainDropdown');
        this.closeBtn = document.getElementById('closeBtn');
        this.categoryItems = document.querySelectorAll('.category-item');
        this.submenuItems = document.querySelectorAll('.submenu-item.has-submenu');
        this.body = document.body;
    }

    bindEvents() {
        // Main dropdown toggle
        this.dropdownTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleDropdown();
        });

        // Close button
        this.closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.closeDropdown();
        });

        // Mobile-only click handlers for categories
        this.categoryItems.forEach(item => {
            const link = item.querySelector('.category-link');
            
            link.addEventListener('click', (e) => {
                // Only handle clicks on mobile/tablet
                if (!this.isDesktop) {
                    e.preventDefault();
                    this.toggleMobileCategory(item);
                }
            });
        });

        // Mobile-only click handlers for submenu items
        this.submenuItems.forEach(item => {
            const link = item.querySelector('.submenu-link');
            
            link.addEventListener('click', (e) => {
                // Only handle clicks on mobile/tablet
                if (!this.isDesktop) {
                    e.preventDefault();
                    this.toggleMobileSubmenu(item);
                }
            });
        });

        // Click outside to close
        // document.addEventListener('click', (e) => {
        //     if (!this.dropdownTrigger.contains(e.target) && 
        //         !this.dropdownMenu.contains(e.target)) {
        //         this.closeDropdown();
        //     }
        // });

        // Escape key to close
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeDropdown();
            }
        });

        // Window resize handler for responsive behavior
        window.addEventListener('resize', () => {
            const wasDesktop = this.isDesktop;
            this.isDesktop = window.innerWidth > 768;
            
            if (wasDesktop !== this.isDesktop) {
                this.handleResponsiveChange();
            }
        });

        // Keyboard navigation
        this.setupKeyboardNavigation();
    }

    toggleMobileCategory(item) {
        const isActive = item.classList.contains('active');
        
        // Close all other categories on mobile
        this.categoryItems.forEach(cat => {
            if (cat !== item) {
                cat.classList.remove('active');
            }
        });
        
        // Toggle current category
        if (isActive) {
            item.classList.remove('active');
        } else {
            item.classList.add('active');
        }
    }

    toggleMobileSubmenu(item) {
        const isActive = item.classList.contains('active');
        
        // Close all other submenus in the same container on mobile
        const parentSubmenu = item.closest('.submenu-list');
        if (parentSubmenu) {
            parentSubmenu.querySelectorAll('.submenu-item.has-submenu').forEach(sub => {
                if (sub !== item) {
                    sub.classList.remove('active');
                }
            });
        }
        
        // Toggle current submenu
        if (isActive) {
            item.classList.remove('active');
        } else {
            item.classList.add('active');
        }
    }

    toggleDropdown() {
        const isOpen = this.dropdownMenu.classList.contains('active');
        
        if (isOpen) {
            this.closeDropdown();
        } else {
            this.openDropdown();
        }
    }

    openDropdown() {
        this.dropdownMenu.classList.add('active');
        this.dropdownTrigger.classList.add('active');
        this.body.style.overflow = this.isDesktop ? 'auto' : 'hidden';
        
        // Clear any default active states on mobile
        if (!this.isDesktop) {
            this.clearMobileActiveStates();
        }
        
        // Focus management
        //this.dropdownMenu.setAttribute('aria-hidden', 'false');
        //this.trapFocus();
    }

    closeDropdown() {
        this.dropdownMenu.classList.remove('active');
        this.dropdownTrigger.classList.remove('active');
        this.body.style.overflow = 'auto';
        
        // Clear mobile active states
        if (!this.isDesktop) {
            this.clearMobileActiveStates();
        }
        
        // Focus management
        this.dropdownMenu.setAttribute('aria-hidden', 'true');
        this.dropdownTrigger.focus();
    }

    clearMobileActiveStates() {
        this.categoryItems.forEach(item => {
            item.classList.remove('active');
        });
        
        this.submenuItems.forEach(item => {
            item.classList.remove('active');
        });
    }

    handleResponsiveChange() {
        // Clear active states when switching modes
        this.clearMobileActiveStates();
        
        // Close dropdown if switching to desktop
        if (this.isDesktop) {
            this.closeDropdown();
        }
        
        // Reset body overflow
        this.body.style.overflow = 'auto';
    }

    setupKeyboardNavigation() {
        // Tab navigation and arrow keys
        this.dropdownMenu.addEventListener('keydown', (e) => {
            const focusableElements = this.getFocusableElements();
            const currentIndex = focusableElements.indexOf(document.activeElement);
            
            switch (e.key) {
                case 'ArrowDown':
                    e.preventDefault();
                    this.focusNext(focusableElements, currentIndex);
                    break;
                    
                case 'ArrowUp':
                    e.preventDefault();
                    this.focusPrevious(focusableElements, currentIndex);
                    break;
                    
                case 'Enter':
                case ' ':
                    e.preventDefault();
                    // Let the browser handle the click
                    document.activeElement.click();
                    break;
            }
        });
    }

    getFocusableElements() {
        return Array.from(this.dropdownMenu.querySelectorAll(
            'a, button, [tabindex]:not([tabindex="-1"])'
        )).filter(el => {
            return el.offsetParent !== null; // visible elements only
        });
    }

    focusNext(elements, currentIndex) {
        const nextIndex = currentIndex < elements.length - 1 ? currentIndex + 1 : 0;
        elements[nextIndex].focus();
    }

    focusPrevious(elements, currentIndex) {
        const prevIndex = currentIndex > 0 ? currentIndex - 1 : elements.length - 1;
        elements[prevIndex].focus();
    }

    trapFocus() {
        const focusableElements = this.getFocusableElements();
        
        if (focusableElements.length === 0) return;
        
        // Focus first element
        focusableElements[0].focus();
        
        // Trap focus within dropdown
        this.dropdownMenu.addEventListener('keydown', (e) => {
            if (e.key === 'Tab') {
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
                
                if (e.shiftKey) {
                    if (document.activeElement === firstElement) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        e.preventDefault();
                        firstElement.focus();
                    }
                }
            }
        });
    }
}

// Smooth scrolling for anchor links
function initSmoothScrolling() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    // Initialize dropdown menu
    const dropdown = new DropdownMenu();
    
    // Initialize smooth scrolling
    initSmoothScrolling();
    
    // Add loading animation
    document.body.classList.add('loaded');
    
    // Performance monitoring
    if ('performance' in window) {
        window.addEventListener('load', () => {
            const loadTime = performance.timing.loadEventEnd - performance.timing.navigationStart;
            console.log(`Page loaded in ${loadTime}ms`);
        });
    }
});

// Service worker registration for PWA capabilities (optional)
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js')
            .then(registration => {
                console.log('SW registered: ', registration);
            })
            .catch(registrationError => {
                console.log('SW registration failed: ', registrationError);
            });
    });
} 


  function convertImgToSvg() {
      // Find all images with class 'menu-icon'
      $('.menu-icon').each(function() {
        const $img = $(this);
        const url = $img.attr('src');

        // Fetch the SVG content using jQuery
        $.get(url)
          .done(function(data) {
            // Parse the SVG response
            const $svgElement = $(data).find('svg').first();

                         if ($svgElement.length) {
               // Get original attributes
               const originalWidth = $svgElement.attr('width');
               const originalHeight = $svgElement.attr('height');
               const originalViewBox = $svgElement.attr('viewBox');
               
               console.log('Original SVG attributes:', {
                 width: originalWidth,
                 height: originalHeight,
                 viewBox: originalViewBox
               });
               
               // Add padding to viewBox if it exists to prevent clipping
               if (originalViewBox) {
                 const viewBoxValues = originalViewBox.split(' ').map(v => parseFloat(v));
                 if (viewBoxValues.length === 4) {
                   const [x, y, width, height] = viewBoxValues;
                   // Add 2 units of padding on all sides
                   const paddedViewBox = `${x - 2} ${y - 2} ${width + 4} ${height + 4}`;
                   $svgElement.attr('viewBox', paddedViewBox);
                   console.log('Padded viewBox:', paddedViewBox);
                 }
               } else if (originalWidth && originalHeight) {
                 // Create viewBox with padding if none exists
                 const w = parseFloat(originalWidth);
                 const h = parseFloat(originalHeight);
                 const paddedViewBox = `-2 -2 ${w + 4} ${h + 4}`;
                 $svgElement.attr('viewBox', paddedViewBox);
                 console.log('Created viewBox with padding:', paddedViewBox);
               }
               
               // Remove width and height to make it responsive
               $svgElement.removeAttr('width height');
               
               // Set preserveAspectRatio for better scaling
               $svgElement.attr('preserveAspectRatio', 'xMidYMid meet');
               
               // Add a class to the SVG for styling
               $svgElement.addClass('menu-svg');
               
               // Copy any existing classes or attributes from the img
               const altText = $img.attr('alt');
               if (altText) {
                 $svgElement.attr('aria-label', altText);
               }

               // Replace the img tag with the SVG element
               $img.replaceWith($svgElement);
             }
          })
          .fail(function(error) {
            console.error('Error fetching or parsing SVG:', error);
          });
      });
    }
const cache = {};

(function wrapJquery($) {
    $.fn.inlineSvg = function fnInlineSvg() {
        this.each(imgToSvg);

        return this;
    };

    function imgToSvg() {
        const $img = $(this);
        const src = $img.attr('src');

        // fill cache by src with promise
        if (!cache[src]) {
            const d = $.Deferred();
            $.get(src, (data) => {
                d.resolve($(data).find('svg'));
            });
            cache[src] = d.promise();
        }

        // replace img with svg when cached promise resolves
        cache[src].then((svg) => {
            const $svg = $(svg).clone();

            if ($img.attr('id')) $svg.attr('id', $img.attr('id'));
            if ($img.attr('class')) $svg.attr('class', $img.attr('class'));
            if ($img.attr('style')) $svg.attr('style', $img.attr('style'));

            if ($img.attr('width')) {
                $svg.attr('width', $img.attr('width'));
                if (!$img.attr('height')) $svg.removeAttr('height');
            }
            if ($img.attr('height')) {
                $svg.attr('height', $img.attr('height'));
                if (!$img.attr('width')) $svg.removeAttr('width');
            }

            $svg.insertAfter($img);
            $img.trigger('svgInlined', $svg[0]);
            $img.remove();
        });
    }
}(jQuery));
    // Run the conversion when the page loads
    //$(document).ready(convertImgToSvg);


     $('img.menu-icon').inlineSvg(); // 100ms delay


    // Run the conversion when the page loads
    //window.addEventListener('DOMContentLoaded', convertImgToSvg);




const merchandise_link = document.querySelectorAll(".front-page .merchandise-link");
const gifts_link = document.querySelectorAll(".front-page .gifts-link");
const experiences = document.querySelectorAll(".front-page .experiences-link");
 $('.content-for-layout .gift_section').closest('section').hide()
 $('.content-for-layout .experiences_section').closest('section').hide();

$('.front-page .category-item.has-submenu a').on('click', function () {
    var url = $(this).attr('href');
    console.log(url);
    if(url == 'https://raywhitemerchandise.co.nz/#experiences'){
        $('.menu-wrapper li').removeClass('menu-active');
        $(".menu-wrapper .experiences-link").closest('li').addClass('menu-active');
        $('.content-for-layout section').hide();
        $('.content-for-layout .experiences_section').closest('section').show();
        $('.content-for-layout .all_tab').closest('section').show();
        $('.content-for-layout .desiable_tab_experiences').closest('section').hide();
    }
}); 


 var currentUrl = window.location.href;
console.log(currentUrl);
if (currentUrl.indexOf('#gift') !== -1) {
    $('.menu-wrapper li').removeClass('menu-active');
    $(".menu-wrapper .gifts-link").closest('li').addClass('menu-active');
    $('.content-for-layout section').hide();
    $('.content-for-layout .gift_section').closest('section').show();
    $('.content-for-layout .all_tab').closest('section').show();
    $('.content-for-layout .desiable_tab_gift').closest('section').hide();
} 
if (currentUrl.indexOf('#experiences') !== -1) {
    $('.menu-wrapper li').removeClass('menu-active');
    $(".menu-wrapper .experiences-link").closest('li').addClass('menu-active');
    $('.content-for-layout section').hide();
    $('.content-for-layout .experiences_section').closest('section').show();
    $('.content-for-layout .all_tab').closest('section').show();
    $('.content-for-layout .desiable_tab_experiences').closest('section').hide();
} 
// Loop through each merchandise link
merchandise_link.forEach(link => {
  link.addEventListener("click", function() {
    $('.menu-wrapper li').removeClass('menu-active');
    $(this).closest('li').addClass('menu-active');
    $('.content-for-layout section').show();
    $('.content-for-layout .gift_section').closest('section').hide();
    $('.content-for-layout .experiences_section').closest('section').hide();
    $('.content-for-layout .all_tab').closest('section').show();
    $('.content-for-layout .desiable_tab_merchandise').closest('section').hide();
  });
});

// Loop through each gifts link
gifts_link.forEach(link => { 
  link.addEventListener("click", function() {
    $('.menu-wrapper li').removeClass('menu-active');
    $(this).closest('li').addClass('menu-active');
    $('.content-for-layout section').hide();
    $('.content-for-layout .gift_section').closest('section').show();
    $('.content-for-layout .experiences_section').closest('section').hide();
    $('.content-for-layout .all_tab').closest('section').show();
    $('.content-for-layout .desiable_tab_gift').closest('section').hide();
  });
});


// Loop through each experiences link
experiences.forEach(link => { 
  link.addEventListener("click", function() {
    $('.menu-wrapper li').removeClass('menu-active');
    $(this).closest('li').addClass('menu-active');
    $('.content-for-layout section').hide();
    $('.content-for-layout .gift_section').closest('section').hide();
    $('.content-for-layout .merchandise_section').closest('section').hide();
    $('.content-for-layout .experiences_section').closest('section').show();
    $('.content-for-layout .all_tab').closest('section').show();
    $('.content-for-layout .desiable_tab_experiences').closest('section').hide();
     
  });
});




$(document).ready(function() {
    setTimeout(function() {
        $('.gift-product-template.defalut_experiences_product button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').show();  
        $('.gift-product-template.defalut_experiences_product button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').text('ADD BRANDING & ADD TO CART');
    }, 5000);       
  setTimeout(function() {
   
    // 1. Detect brand selection change
     $('button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').text('Voucher Delivery Form');
     $('.experiences_product button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').show();
    $('body.experiences_product .brand_name input').on('input', function() {
      $('button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').text('Voucher Delivery Form');
      var selectedBrand = $('.brand_name input:checked').val();
      if (!selectedBrand) {
        $('.error_mgs').show();
        $('button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').hide();
      } else {
        $('.error_mgs').hide();
        $('.button_custom').hide();
        $('button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').show();
      }
    });

    // 2. On custom button click
    $('body.experiences_product .button_custom').on('click', function(e) {
      $('button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').text('Voucher Delivery Form');
      var selectedBrand = $('.brand_name input:checked').val();
      if (!selectedBrand) {
        e.preventDefault();
        $('.error_mgs').show();
        $('button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').hide();
      } else {
        $('.error_mgs').hide();
        $('.button_custom').hide();
        $('button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').show().click();
      }
    });

    // 3. When the hidden modal button is triggered
    $('body.experiences_product .tpo-show-popup').on('click', function () {
      var voucher_quantity = $('#voucher_quantity').val(); 
      var voucher_amount = $('#voucher_amount').val(); 
      var selectedBrand = $('.brand_name input:checked').val();

      $('.tpo_modal-container input[name="properties[Voucher Quantity]"]').val(voucher_quantity);
      $('.tpo_modal-container input[name="properties[Voucher Amount]"]').val(voucher_amount);

      if (selectedBrand === 'RWC') {
        $('input#RWC-0').prop('checked', true).addClass('tpo_checked');
      }
      if (selectedBrand === 'RayWhite') {
        $('input#RWC-1').prop('checked', true).addClass('tpo_checked');
      }
    });
    $('body.gift-product-template button.tpo_open-modal-button.tpo_edit-option-modal.tpo-show-popup').on('click', function () {
        $('body').addClass('experiences_product_cart');
    });
    
    $('body.experiences_product_cart span.tpo_close-popup-button').on('click', function () {
        $('body').removeClass('experiences_product_cart');
    });
  }, 2000);   
});


//Footer Script
$(document).ready(function() {
  // if ($(window).width() < 980) {
  //   $(document).on('click', '.front-page li#full-width-menu a', function() {
  //     location.reload();
  //   });
  // }
  let option_not_fills = $('.product-form__input input:checked').val();
   setTimeout(function() {
    if(option_not_fills == 'Not Personalised') {
      $('.product__media-wrapper').addClass('non-personalised-img');
      const listItemCount = $('.thumbnail-slider ul li').length;
      if(listItemCount >= 3) {
        $('.thumbnail-slider ul li:eq(2) button').click();
      }else {
        $('button.slider-button.slider-button--next').click();
      }
      //$('button.slider-button.slider-button--next').click();  
    }
   }, 3500);
});   
$(document).on('click', '.personalised-pro .product-form__input label', function() {
  var option_label = $(this).clone().children().remove().end().text().trim();
  if(option_label == 'Personalised') {
    setTimeout(function() {
     location.reload();
    }, 500);  
  }else if(option_label == 'Not Personalised') {
    setTimeout(function() {
      $('.product__media-wrapper').addClass('non-personalised-img');
      const listItemCount = $('.thumbnail-slider ul li').length;
      if(listItemCount >= 3) {
        $('.thumbnail-slider ul li:eq(2) button').click();
      }else {
        $('button.slider-button.slider-button--next').click();
      }
      //$('button.slider-button.slider-button--next').click();
    }, 1000);  
  }
  // else {
  //   setTimeout(function() {
  //   $('button.slider-button.slider-button--next').click();
  //   }, 500);  
  // }
  setTimeout(function() {
  $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').hide();
     $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }, 500);
});  
  
$(document).on('click', '.personalised-pro .product-form__input .price-per-item__container .quantity__button[name="plus"]', function() {
  const plus_quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
  let plus_currentQuantitys = parseInt(plus_quantityInput.val()) || 0;
  let option_not_fill = $('.product-form__input input:checked').val();
  if(plus_currentQuantitys >= 2 && option_not_fill != 'Not Personalised') {
    $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').show();
    $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }else {
    $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').hide();
    $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }
});
$(document).on('click', '.personalised-pro .product-form__input .price-per-item__container .quantity__button[name="minus"]', function() {
  const minus_quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let minus_currentQuantitys = parseInt(minus_quantityInput.val()) || 0;
  let option_not_fill = $('.product-form__input input:checked').val();
  if(minus_currentQuantitys >= 2 && option_not_fill != 'Not Personalised') {
    $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').show();
    $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }else {
    $('.pplr-wrapper.pplr-text.pplr-additional-names-separate-each-name-with-a-comma').hide();
    $('.pplr-additional-names-separate-each-name-with-a-comma textarea').val('');
  }
});  
  
  $(document).on('click', '.cart_plus_ten .plus_ten .quantity__button[name="plus"]', function() {
    const steps_plus = 10;
    const quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let currentQuantitys = parseInt(quantityInput.val()) || 0;
    let currentQuantity = currentQuantitys - 1;
    quantityInput.val(currentQuantity + steps_plus); // Increase by 10
  });
  
  $(document).on('click', '.cart_plus_ten .plus_ten .quantity__button[name="minus"]', function() {
    const steps = 10;
    const quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let currentQuantitys = parseInt(quantityInput.val()) || 0;
    console.log(currentQuantitys);
     let currentQuantity = currentQuantitys + 1;
    if (currentQuantity > steps) {
      quantityInput.val(currentQuantity - steps); // Decrease by 10
    }
  });
  
  $(document).on('click', '.cart_golf_ball_bundle .cart_golf_ball_inc .quantity__button[name="plus"]', function() {
    const golf_steps = 12;
    const quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let currentQuantitys = parseInt(quantityInput.val()) || 0;
    let currentQuantity = currentQuantitys - 1;
    quantityInput.val(currentQuantity + golf_steps); // Increase by 10
  });
  
  $(document).on('click', '.cart_golf_ball_bundle .cart_golf_ball_inc .quantity__button[name="minus"]', function() {
    const golf_steps = 12;
    const quantityInput = $(this).siblings('.quantity__input'); // Selects the quantity input near the clicked button
    let currentQuantitys = parseInt(quantityInput.val()) || 0;
     let currentQuantity = currentQuantitys + 1;
    if (currentQuantity > golf_steps) {
      quantityInput.val(currentQuantity - golf_steps); // Decrease by 10
    }
  });  


  $(".collection-card-wrapper").hover(
  function () {
    // mouse enters
    $(this).find("p.card__caption.link").stop(true, true).fadeIn(200);
  },
  function () {
    // mouse leaves
    $(this).find("p.card__caption.link").stop(true, true).fadeOut(200);
  }
);


// popup Code
  $(".popup-btn").on( "click", function(e) {
    e.preventDefault();
    $('body').addClass('active-popup');
    var popup_id = $(this).data('popup');
    var targetPopup = $('.popup-modal[data-id="' + popup_id + '"]');
    targetPopup.css("display", "block").addClass("active");
  });  

// Close popup
  document.querySelectorAll('.close-popup').forEach(closeBtn => {
    closeBtn.addEventListener('click', function () {
      const popup = this.closest('.popup-modal');
      if (popup) {
        $('body').removeClass('active-popup');
        popup.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  });

// Close popup when clicking outside the content
  window.addEventListener('click', function (event) {
    document.querySelectorAll('.popup-modal').forEach(modal => {
      if (event.target === modal) {
        $('body').removeClass('active-popup');
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  });

// Close popup on pressing Esc
window.addEventListener('keydown', function (event) {
  if (event.key === "Escape") {
    document.querySelectorAll('.popup-modal').forEach(modal => {
      if (modal.style.display === "block") { // Only close if the modal is open
        $('body').removeClass('active-popup');
        modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }
});  